var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-list",
    [
      _c(
        "w-list-item",
        [
          _c("w-list-item-text", { staticClass: "bold" }, [_vm._v("Naam")]),
          _c("w-list-item-text", { staticClass: "bold" }, [
            _vm._v("Omschrijving"),
          ]),
          _c("w-list-item-action"),
        ],
        1
      ),
      _vm._l(_vm.params, function (param, i) {
        return _c(
          "w-list-item",
          { key: param.id },
          [
            _c(
              "w-list-item-text",
              [
                _c("w-input", {
                  attrs: { "has-error": !_vm.isParamNameValid(param.Name) },
                  model: {
                    value: param.Name,
                    callback: function ($$v) {
                      _vm.$set(param, "Name", $$v)
                    },
                    expression: "param.Name",
                  },
                }),
              ],
              1
            ),
            _c(
              "w-list-item-text",
              [
                _c("w-textarea", {
                  model: {
                    value: param.Description,
                    callback: function ($$v) {
                      _vm.$set(param, "Description", $$v)
                    },
                    expression: "param.Description",
                  },
                }),
              ],
              1
            ),
            _c(
              "w-list-item-action",
              [
                _c(
                  "w-button",
                  {
                    staticClass: "danger",
                    on: {
                      click: function ($event) {
                        return _vm.removeParam(i)
                      },
                    },
                  },
                  [_c("w-fa", { attrs: { icon: "trash" } })],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      }),
      _c(
        "w-list-item",
        {
          on: {
            click: function ($event) {
              return _vm.addParam()
            },
          },
        },
        [
          _c("w-list-item-icon", [_c("w-fa", { attrs: { icon: "plus" } })], 1),
          _c("w-list-item-text", [_vm._v(" Parameter toevoegen ")]),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }